"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const utils_1 = require("../utils");
/**
 * Set the refund reason for an order
 * @param event
 * @param prevState
 */
function default_1(event, prevState) {
    const order = (0, utils_1.clone)(prevState);
    return { ...order, reason: event.reason };
}
exports.default = default_1;
//# sourceMappingURL=assignRefundReason.js.map